import { TaskWorkflowByProfile } from './task-workflow-by-profile';

export class Affectation {
    id: number|undefined;
    active:boolean;
    profileCode:string;
    taskWorkflowByProfile:TaskWorkflowByProfile;
  }